import React, { useState, useEffect, useRef } from 'react';
import DOMPurify from 'dompurify';
import Cookies from 'universal-cookie';
import BaseService from 'services/base/base.service';
import { useTranslation } from 'react-i18next';
import { Switch } from 'antd';

const cookies = new Cookies();

const CookiesToolsWidget = (props) => {
	const page = "cookies_settings";
	const refModal = useRef(null);
	const [showInfo, setShowInfo] = useState(false);
	const [content, setContent] = useState(false);
	const [cookiesCustomizeSettings, setCookiesCustomizeSettings] = useState(false);
	const [saveCookie, setSaveCookie] = useState(false);

	const [cookiesConfig, setCookiesConfig] = useState({
		necessary: true,
		functional: true,
		analytics: true,
		advertisement: true
	});

	const saveHandler = () => {
		cookies.set('accept_cookies', cookiesConfig, [{
			path: '/',
			maxAge: 2592000
		}]);
		setShowInfo(false);
		setCookiesCustomizeSettings(false);
		window.location.reload();
	};

	const saveCustomHandler = () => {
		setSaveCookie(true);
	};

	const saveAllHandler = () => {
		setCookiesConfig({
			...cookiesConfig,
			functional: true,
			analytics: true,
			advertisement: true
		});
		setSaveCookie(true);
	};

	useEffect(() => {
		if (saveCookie) {
			saveHandler();
		}
	}, [cookiesConfig, saveCookie]);

	const CookieSettings = () => {
		const { t } = useTranslation();
		return !content || !content.purpose ? null :
			<>
				<div className="modal-head pb-3 mb-3">
					<h3 className="mb-4">{content?.preferences?.title}</h3>
					<p className="editor" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content?.preferences?.descriptions || '') }}></p>
				</div>
				<div className="modal-body">
					<p className="text-big mb-3">{content?.purpose?.title}</p>
					<p className="modal-item text-small text-bold mb-3">{t('cookies_settings.Necessary')}<span className="text-green">{t("Always Active")}</span></p>
					<p className="editor mb-4" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content?.purpose?.necessary_descriptions || '') }}></p>
					<div className="modal-item text-small text-bold mb-3">
						{t('cookies_settings.Functional')}
						<Switch data-test-id="cookie-switch-functional" onChange={(e) => {
							setCookiesConfig({ ...cookiesConfig, functional: !cookiesConfig.functional });
						}} checked={cookiesConfig.functional} />
					</div>
					<p className="editor mb-4" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content?.purpose?.functional_descriptions || '') }}></p>
					<div className="modal-item text-small text-bold mb-3">
						{t('cookies_settings.Analytics')}
						<Switch data-test-id="cookie-switch-analytics" onChange={(e) => {
							setCookiesConfig({ ...cookiesConfig, analytics: !cookiesConfig.analytics });
						}} checked={cookiesConfig.analytics} />
					</div>
					<p className="editor mb-4" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content?.purpose?.analytics_descriptions || '') }}></p>
					<div className="modal-item text-small text-bold mb-3">
						{t('cookies_settings.Advertisement')}
						<Switch data-test-id="cookie-switch-advertisement" onChange={(e) => {
							setCookiesConfig({ ...cookiesConfig, advertisement: !cookiesConfig.advertisement });
						}} checked={cookiesConfig.advertisement} />
					</div>
					<p className="editor mb-5" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content?.purpose?.advertisement_descriptions || '') }}></p>
					<div className="d-flex justify-content-center justify-content-sm-end align-items-center">
						<button data-test-id="cookie-save-preferences" onClick={() => { saveCustomHandler(); }} type="button" className="btn-filter-reset bg-light mr-4 text-medium text-decoration-none text-white text-semibold h-32 d-inline-flex justify-content-center align-items-center px-12">{t('buttons.accept_preferences')}</button>
						<button data-test-id="cookie-save-all" onClick={() => { saveAllHandler(); }} type="button" className="btn-filter-apply bg-light text-medium text-decoration-none text-white text-semibold h-32 d-inline-flex justify-content-center align-items-center px-12">{t('buttons.accept_all_cookie')}</button>
					</div>
				</div>
			</>;

	};

	const CookieBanner = () => {
		const { t } = useTranslation();
		const [bannerHeight, setBannerHeight] = useState(156)

		useEffect(() => {
			const offsetHeight = document.querySelector('.banner.container-xl')?.offsetHeight ?? 0
			setBannerHeight(offsetHeight);
		}, [])

		return !content || !content.banner ? null :
			<div data-test-id="cookie-banner-wr" style={{ marginTop: "-" + bannerHeight + "px" }} className={'banner container-xl w-100 py-4' + (showInfo ? ' d-block' : ' d-none')}>
				<p className="text-white text-medium text-sm-small text-bold mb-3">{content?.banner?.title}</p>
				<p className="editor bg-dark mb-3" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content?.banner?.descriptions || '') }}></p>
				<div className="d-flex justify-content-between align-items-center">
					<a data-test-id="cookie-preferences" href="#link_cookies_customize_settings" onClick={handleOpenCookiesPopup} className="btn-filter-reset text-medium text-decoration-none text-white text-semibold h-32 d-inline-flex justify-content-center align-items-center px-12">
						{t('buttons.Cookies preference')}
					</a>
					<a data-test-id="cookie-accept" href="#accept_cookies" onClick={() => { saveHandler(); }} className="btn-filter-apply text-medium text-decoration-none text-white text-semibold h-32 d-inline-flex justify-content-center align-items-center px-12">
						{t('buttons.btn_accept_cookies')}
					</a>
				</div>
			</div>;

	};

	const handleClickOutside = (event) => {
		if (refModal.current && !refModal.current.contains(event.target)) {
			setCookiesCustomizeSettings(false);
		}
	};

	const handleOpenCookiesPopup = () => {
		setCookiesCustomizeSettings(true);
	};

	useEffect(() => {
		let accept_cookies = cookies.get('accept_cookies');
		let not_accept_cookies = cookies.get('not_accept_cookies');

		if (not_accept_cookies === 1) {
			setShowInfo(false);
		} else {
			setShowInfo(!accept_cookies);
			setCookiesConfig({ ...cookiesConfig, ...accept_cookies });
		}
	}, [setCookiesConfig, setShowInfo]);

	useEffect(() => {
		if (content === false) {
			BaseService.getContent({ page }).then((res) => {
				setContent(res);
			}).catch((err) => { });
		}
	}, []);

	useEffect(() => {
		document.addEventListener('openCookiesPopup', handleOpenCookiesPopup);
		return () => {
			document.removeEventListener('openCookiesPopup', handleOpenCookiesPopup);
		};
	}, []);

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});

	if (!content) return null;

	return (
		<>
			<CookieBanner />
			<div className={'modal w-100' + (cookiesCustomizeSettings ? ' d-flex justify-content-center align-items-center' : ' d-none')}>
				<div ref={refModal} className='modal-window mx-2 p-4'>
					<button data-test-id="cookie-x" onClick={() => {
						setCookiesCustomizeSettings(!cookiesCustomizeSettings);
					}} type="button" className="btn-close text-bold">X</button>
					<CookieSettings />
				</div>
			</div>
		</>);

};

export default CookiesToolsWidget;